module.exports = __webpack_public_path__ + "img/ico-scrap-22.d4a32e72.svg";